import { render, staticRenderFns } from "./AutoNumberInput.vue?vue&type=template&id=5a629011&scoped=true&"
import script from "./AutoNumberInput.vue?vue&type=script&lang=js&"
export * from "./AutoNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a629011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a629011')) {
      api.createRecord('5a629011', component.options)
    } else {
      api.reload('5a629011', component.options)
    }
    module.hot.accept("./AutoNumberInput.vue?vue&type=template&id=5a629011&scoped=true&", function () {
      api.rerender('5a629011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/AutoNumberInput.vue"
export default component.exports